import { Button, Card, Descriptions, Message, Space, Table } from "@arco-design/web-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { InvMovementOrderAPI } from "@/apis/material";
import { Number } from "@/components/Numeric";
import { DateTime } from "@/components/DateTime";

export const InvMovementInfo = () => {
    const navigate = useNavigate();
    const params = useParams();
    const id = params.id;
    const [loading, setLoading] = useState(false);
    const [info, setInfo] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = await InvMovementOrderAPI.get(id);
                setInfo(data);
            } catch (error) {
                Message.error(error.message || "Failed to load movement order");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    if (!info) {
        return <Card loading={loading}>Loading...</Card>;
    }

    const items = (info.items || []).map((item, i) => ({ ...item, _key: i }));

    const columns = [
        {
            title: (<div style={{ lineHeight: 1.5 }}><div style={{ fontSize: 14, fontWeight: 600 }}>Item Name</div><div style={{ fontSize: 12, color: '#86909c' }}>Description</div></div>),
            width: 280,
            render: (col, row) => (
                <div style={{ lineHeight: 1.5 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#1d2129' }}>{row.itemName || ""}</div>
                    <div style={{ fontSize: 12, color: '#86909c' }}>{row.itemDescription || ""}</div>
                </div>
            ),
        },
        { title: "Warehouse", dataIndex: "fromWarehouseName", width: 160 },
        { title: "Location", dataIndex: "fromLocationName", width: 140 },
        { title: "Lot#", dataIndex: "fromLot", width: 120 },
        {
            title: "Qty",
            width: 100,
            render: (col, row) => <Number value={row.qty} />,
        },
        {
            title: "Qty To Move",
            width: 140,
            render: (col, row) => <Number value={row.qtyToMove} />,
        },
        { title: "Warehouse", dataIndex: "toWarehouseName", width: 160 },
        { title: "Location", dataIndex: "toLocationName", width: 140 },
    ];

    const groupedColumns = [
        {
            title: "Move From",
            children: columns.slice(0, 6),
        },
        {
            title: "Move To",
            children: columns.slice(6, 8),
        },
    ];

    const headerData = [
        { label: "User", value: info.userName || "-" },
        { label: "Time", value: info.createTime ? <DateTime value={info.createTime} /> : "-" },
    ];

    return (
        <Card title={info.movementNo || `Movement Order #${id}`} extra={
            <Space>
                <Button onClick={() => navigate(-1)}>Back</Button>
            </Space>
        }>
            <Descriptions colon=":" column={2} data={headerData} />
            <Descriptions colon=":" column={1} data={[
                { label: "Notes", value: info.notes || "-" },
            ]} style={{ marginTop: 8 }} />
            {info.sameLocation && (
                <Descriptions colon=":" column={2} data={[
                    { label: "Same Location", value: "Yes" },
                    { label: "Move To", value: `${items[0]?.toWarehouseName || "-"} / ${items[0]?.toLocationName || "-"}` },
                ]} style={{ marginTop: 8 }} />
            )}

            <div style={{ marginTop: 16 }}>
                <Table
                    rowKey="_key"
                    loading={loading}
                    columns={groupedColumns}
                    data={items}
                    pagination={false}
                    border={{ wrapper: true, cell: true }}
                />
            </div>
        </Card>
    );
};